import { ParsedUrlQuery, stringify } from 'querystring';

import config from 'config';
import { copyRedirectTargetUrl, copySearchParams } from 'consts/keyboardShortcuts';
import { paramsOutsideAlias } from 'consts/filters';
import getSortedQueryParams from 'utils/getSortedQueryParams';
import omit from 'utils/omit';
import { useIntl } from 'utils/intl';
import useKeyboardShortcut from 'hooks/useKeyboardShortcut';

import messages from './SearchKeyPress.messages';

const { routes } = config;

const getSerializedParams = (query: ParsedUrlQuery): string =>
  stringify(getSortedQueryParams(omit(query, [...paramsOutsideAlias, 'alias'])));

type Props = {
  query: ParsedUrlQuery;
};

const SearchKeyPress = ({ query }: Props): JSX.Element => {
  const intl = useIntl();

  useKeyboardShortcut(copySearchParams, async ({ showMessage }) => {
    if ('navigator' in window && navigator.clipboard) {
      await navigator.clipboard.writeText(getSerializedParams(query));
      showMessage('info', intl.formatMessage(messages.paramsCopied));
    }
  });

  useKeyboardShortcut(copyRedirectTargetUrl, async ({ showMessage }) => {
    if ('navigator' in window && navigator.clipboard) {
      await navigator.clipboard.writeText(`${routes.search.href}?${getSerializedParams(query)}`);
      showMessage('info', intl.formatMessage(messages.targetUrlCopied));
    }
  });

  return <></>;
};

export default SearchKeyPress;
